<template>
	<v-container 
		fluid
		fill-height
		class="authentication-container"
	>
		<v-layout>
			<v-flex md3>
				<!-- Inserire qui il contenuto dei container laterali -->
				<template v-if="!isRegistering">
					<v-layout 
						align-center 
						justify-center
						fill-height
						>
							<v-flex blue-grey--text> 
								<img
								src="@/assets/buyandsell.gif"
								width="90%"
								/>
								
								<v-flex pb-2>Tokenize your assets. Buy and sell with a click. The new platform based on ethereum blockchain technology that allows you to exchange your digital assets.</v-flex>
								<v-flex pb-2><v-icon small color="blue-grey darken-1">fas fa-building</v-icon> Properties</v-flex>
								<v-flex pb-2><v-icon small color="blue-grey darken-1"> fas fa-gavel</v-icon> Actions</v-flex>
								<v-flex pb-2><v-icon small color="blue-grey darken-1">fas fa-store</v-icon> Activity</v-flex>
								<v-flex pb-2><v-icon small color="blue-grey darken-1">fas fa-chart-area</v-icon> Bussines</v-flex>
								<v-flex pb-2><v-icon small color="blue-grey darken-1">fas fa-project-diagram</v-icon> New bussines project</v-flex>
								<v-flex pb-2><v-icon small color="blue-grey darken-1">fas fa-brain</v-icon> Creativity </v-flex>
								
								<v-flex mb-2>Our platform was designed to be extremely scalable,
										this allows a continuous development to insert new assets.</v-flex>

								<span>For more information send e-mail: </span>
								<span class="font-weight-bold subtitle-2">info@re121.com</span>
							</v-flex>
						</v-layout>
					</template>

					<template v-else>
						<v-layout 
							align-center 
							justify-center
							fill-height
						>
							<v-flex blue-grey--text> 
								
								<p class="font-weight-black display-2">Thank You</p>
								<p class="font-weight-bold headline">for choosing to register. </p>

								<v-flex pb-2>In this phase you will be asked for some information to 
									access the platform and, if you want, upload the documents if you want to operate.
									Follow the instructions.</v-flex>
								<span>For support send e-mail: </span>
								<span class="font-weight-bold subtitle-2">support@re121.com</span>

								<v-flex pb-5></v-flex>	
								<v-chip color="blue-grey" >step 1</v-chip>
								<v-flex mb-2>In this phase you must enter a valid e-mail, 
									then you will be asked for a verification and choose your password. 
									Remember to mark the password somewhere and keep it safe</v-flex>
								<v-flex pb-5></v-flex>	
								<v-chip color="blue-grey" >step 2</v-chip>
								<v-flex mb-2>In this phase you must enter your name and surname, residential address, 
								a valid phone number, even the phone number of a mobile phone, and select the state of belonging.</v-flex>
							</v-flex>
						</v-layout>	
					</template>
      </v-flex>

			<v-flex>
				<template v-if="!isRegistering">
					<login />
				</template>

				<template v-else>
					<signup />
				</template>
			</v-flex>
			
			<v-flex md3>
        <!-- Inserire qui il contenuto dei container laterali -->
				<template v-if="!isRegistering">
					<v-layout
						align-center
						justify-center
						fill-height
					>
						<img
						src="@/assets/world.gif"
						width="160%"
						/>
		<!-- Gentilemnte non toccare la percentuale...		  -->				
					</v-layout>
				</template>
				<template v-else>
					<v-layout 
						align-center 
						justify-center
						fill-height
						>
							<v-flex blue-grey--text> 
								<v-flex pb-5 > </v-flex>	
								<v-chip color="blue-grey" >step 3</v-chip>
								<v-flex mb-2>In this phase you must enter the news related to your crypto wallet. 
									You must enter the public address of the portfolio that will operate on our platform.
									 Warning: you only need to enter the public key only. 
									Once this is done, the platform queries your wallet and then synchronizes it.</v-flex>
								<v-flex pb-5></v-flex>	
								<v-chip color="blue-grey" >step 4</v-chip> 
								<v-flex mb-2>If you want to buy and sell assets, buy our tokenized assets and do any other operation, 
									you must enter a copy of the requested documents. 
									This step is not mandatory if you just want to buy our standard tokens.</v-flex>
							</v-flex>
						</v-layout>	
				</template>
      </v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			showLogin: true,
			showSignup: false
		}
	},

	computed: {
		...mapState ({
			isRegistering: state => state.ui.isRegistering
		})
	},

	watch: {
		
	},

	methods: {
		
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.authentication-container {
	background-color: $primary;
	z-index: 10;
	
}

</style>
